import gql from 'graphql-tag';

export const GET_SUMMARY_TEMPLATES = gql`
    query GetSummaryTemplates {
        summaryTemplates(first: 100) {
            data {
                id
                name
                description
                school {
                    id
                    name
                }
                properties
                columns {
                    id
                    label
                    key
                    type
                    group
                    sequence
                    is_visible
                    calculation_function
                    calculation_arguments
                }
            }
        }
    }
`;

export const GET_SUMMARY_REPORT = gql`
    query GetSummaryReport(
        $templateId: ID!
        $calId: ID!
        $programmeId: ID
        $classroomId: ID
        $level: String
        $calculationMethod: String
        $retakeMethod: String
        $student_status: String
    ) {
        summaryReport(
            summary_template_id: $templateId
            academic_calendar_id: $calId
            programme_id: $programmeId
            classroom_id: $classroomId
            level: $level
            calculation_method: $calculationMethod
            retake_method: $retakeMethod
            student_status: $student_status
        ) {
            headers
            data
            summary
            meta
            failed_courses
            course_headers
            course_legend
        }
    }
`;

export const GET_SUMMARY_EXCEL_URL = gql`
    query GetSummaryExcelUrl(
        $templateId: ID!
        $calId: ID!
        $programmeId: ID!
        $level: String
        $calculationMethod: String
        $retakeMethod: String
    ) {
        summaryExcelUrl(
            summary_template_id: $templateId
            academic_calendar_id: $calId
            programme_id: $programmeId
            level: $level
            calculation_method: $calculationMethod
            retake_method: $retakeMethod
        ) {
            id
            status
            file_name
            file_url
        }
    }
`;

export const GET_SUMMARY_PDF_URL = gql`
    query GetSummaryPdfUrl(
        $templateId: ID!
        $calId: ID!
        $programmeId: ID!
        $level: String
        $calculationMethod: String
        $retakeMethod: String
    ) {
        summaryPdfUrl(
            summary_template_id: $templateId
            academic_calendar_id: $calId
            programme_id: $programmeId
            level: $level
            calculation_method: $calculationMethod
            retake_method: $retakeMethod
        ) {
            id
            status
            file_name
            file_url
        }
    }
`;
